import { cn } from '@/shared/lib/cn';

export interface KeyValueItem {
  label: React.ReactNode;
  value: React.ReactNode;
  /** Span the full row in a multi-column list. */
  wide?: boolean;
}

export interface KeyValueListProps {
  items: readonly KeyValueItem[];
  /** Columns (gap 16). Default 2 (586:17339). */
  columns?: 1 | 2 | 3;
  /** Placeholder for empty values. Default "—". */
  emptyValue?: React.ReactNode;
  className?: string;
}

/** One pair: caps label (600 11/15 White/60) over the value (600 14/21 white), gap 4 (586:17460). */
export function KeyValue({ label, value, emptyValue = '—', className }: KeyValueItem & { emptyValue?: React.ReactNode; className?: string }) {
  const empty = value == null || value === '';
  return (
    <div className={cn('flex min-w-0 flex-col gap-4', className)}>
      <dt className="t-caps">{label}</dt>
      <dd className={cn('text-sm leading-21 font-semibold tracking-normal break-words', empty ? 'text-fg-tertiary' : 'text-fg')}>
        {empty ? emptyValue : value}
      </dd>
    </div>
  );
}

/** Read-only details grid ("Batafsil ma'lumot" modal 586:17184): rows gap 14, columns gap 16. */
export function KeyValueList({ items, columns = 2, emptyValue, className }: KeyValueListProps) {
  return (
    <dl
      className={cn(
        'grid gap-x-16 gap-y-14',
        columns === 1 ? 'grid-cols-1' : columns === 2 ? 'grid-cols-2' : 'grid-cols-3',
        className,
      )}
    >
      {items.map((item, i) => (
        <KeyValue key={i} {...item} emptyValue={emptyValue} className={item.wide ? 'col-span-full' : undefined} />
      ))}
    </dl>
  );
}
